/* eslint-disable max-len */
import { CONVIVA_CUST_KEY_TEST, CONVIVA_CUST_KEY_PROD } from '../../constants'

// Conditionally import Conviva only on client side to prevent SSR issues
let convivaAppTracker; let trackPageView; let trackCustomEvent; let
  setUserId

const loadConvivaLibrary = async () => {
  if (typeof window !== 'undefined' && !convivaAppTracker) {
    const convivaModule = await import('@convivainc/conviva-js-appanalytics')
    convivaAppTracker = convivaModule.convivaAppTracker
    trackPageView = convivaModule.trackPageView
    trackCustomEvent = convivaModule.trackCustomEvent
    setUserId = convivaModule.setUserId
  }
}

export async function trackEvent(name, detail) {
  // Only proceed if we're on the client side
  if (typeof window === 'undefined') {
    return null
  }

  // Ensure Conviva library is loaded
  await loadConvivaLibrary()

  const events = {
    directPageView: 'page_load',
    rwcVipClick: 'rwc_vip_click',
    premierSports: 'premier_sports',
    playerPlus: 'player_plus',
    pplusSignupClick: 'start_pplus_signup',
    homepageClick: 'page_load',
    rowClick: 'row_click',
    launchEvent: 'visit_launch',
    deepLink: 'deeplink_open',
    addMyList: 'add_my_list',
    removeFromMylist: 'remove_my_list',
    vodContentStart: 'vod_content_start',
    liveContentStart: 'live_programme_start',
    liveViewingBoundaryChange: 'live_viewing_boundary_change',
    livePlays: 'live_play',
    liveProgrammeChange: 'live_programme_change',
    liveViewingStart: 'live_viewing_start',
    liveViewingEnd: 'live_viewing_end',
    liveProgrammeViewingStartTime: 'live_programme_viewing_start_time',
    categoryView: 'category_view',
    PplusNavUpgrade: 'pplus_nav_upgrade',
    viewEpisodes: 'view_episodes',
    liveScrubbing: 'live_scrubbing',
    recomNextEp: 'recom_next_ep',
    recomNextProg: 'recom_next_prog',
    recomPromotedProg: 'recom_promoted_prog',
    vodSubtitleStatus: 'report_subtitle_status',
    watchCredits: 'watch_credits',
    liveSubtitleStatus: 'report_live_subtitle_status',
    pipOpen: 'pip_open',
    pipClose: 'pip_close',
    pipOpenVod: 'pip_open_vod',
    pipCloseVod: 'pip_close_vod',
  }

  const directCallEvents = [
    'page_load',
    'rwc_vip_click',
    'premier_sports',
    'start_pplus_signup',
    'homepage_click',
    'live_scrubbing',
    'visit_launch',
    'deeplink_open',
    'row_click',
    'report_live_subtitle_status',
    'report_subtitle_status',
    'add_my_list',
    'remove_my_list',
    'pip_open',
    'pip_close',
    'pip_open_vod',
    'pip_close_vod',
    'vod_content_start',
    'live_programme_start',
    'live_viewing_end',
    'recom_next_prog',
    'category_view',
    'pplus_nav_upgrade',
    'view_episodes',
    'player_plus',
    'recom_next_ep',
    'recom_next_prog',
    'live_viewing_start',
    'recom_promoted_prog',
    'watch_credits',
    'live_programme_change',
    'live_viewing_boundary_change',
    'live_play',
    'live_programme_viewing_start_time',
  ]

  if (!Object.keys(events).includes(name)) {
    return null
  }

  if (directCallEvents.includes(events[name])) {
    if (name === 'directPageView') {
      trackPageView(detail || {
        pageUrl: window.location.href,
        title: detail.pagename,
      })
    }
    trackCustomEvent({
      name: events[name],
      data: detail || {},
    })
    return null
  }
  return null
}

export const initConvivaTracking = async (userId, isProd) => {
  // Only proceed if we're on the client side
  if (typeof window === 'undefined') {
    return
  }

  // Ensure Conviva library is loaded
  await loadConvivaLibrary()

  convivaAppTracker({
    appId: 'player',
    convivaCustomerKey: isProd ? CONVIVA_CUST_KEY_PROD : CONVIVA_CUST_KEY_TEST,
    appVersion: '1.1.0',
    contexts: {
      performanceTiming: true,
    },
  })
  setUserId(userId || 'user-not-logged-in')
}

/*
  recommended_click
  item: Row Name, Row Index, Item Index, Item Name, Recommendation ID
  trackEvent(customEventTags.recommendationClick, { item: 'Recommended For You, 1, 1, Loose Women, 3224d74454a3ab2797e7987d0bfe32966a502a80' })
*/
export function recommendedClick(rowName, rowIndex, itemIndex, itemName, recommendationId) {
  trackEvent('recommendationClick', { item: `${rowName}, ${rowIndex}, ${itemIndex}, ${itemName}, ${recommendationId}` })
}

export const resetConvivaAnalytics = () => {
  // Only proceed if we're on the client side
  if (typeof window === 'undefined') {
    return
  }

  if (window.ConvivaVideoAnalytics) {
    window.ConvivaVideoAnalytics.release()
    window.ConvivaVideoAnalytics = null
  }
  if (window.ConvivaAdAnalytics) {
    window.ConvivaAdAnalytics.release()
    window.ConvivaAdAnalytics = null
  }

  window?.Conviva?.Analytics.release()
}
